module.exports = __webpack_public_path__ + "img/5.3661d79d.png";